import React, { useEffect } from 'react';
import useStyles from '../../../booking-details/OnTripAnnouncement/styles';
import DialogModal from 'views/ui-elements/commons/dialogModal';
import * as yup from 'yup';
import { Box, Button, Grid, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import MainCard from 'ui-component/cards/MainCard';
import { useTheme } from '@emotion/react';
import { resetAddViewData } from 'store/slices/coupons';
import { dispatch } from 'store';

const commonTableColumns = ['Description', 'Category', 'Coupon Usage Count', 'Max Usage Count', 'Created by', 'Created at'];
const ViewHistoryModalBody = ({ setViewHistoryModal }) => {
    const classes = useStyles();
    const { viewHistoryLoading = false, viewHistoryData = [] } = useSelector((state) => state.coupons);
    const theme = useTheme();
    // eslint-disable-next-line arrow-body-style
    useEffect(() => {
        return () => {
            dispatch(resetAddViewData());
        };
    }, []);
    const TabelHeader = () =>
        commonTableColumns?.map((columnName) => <TableCell className={classes.announcementCardHeadingText}>{columnName}</TableCell>);
    const NoViewHistoryAvailable = () => {
        if (!viewHistoryData || viewHistoryData?.length <= 0) {
            return (
                <TableRow>
                    <TableCell colSpan={commonTableColumns?.length}>
                        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>No view history available</Box>
                    </TableCell>
                </TableRow>
            );
        }
        return <></>;
    };
    return (
        <>
            <MainCard content={false}>
                <TableContainer>
                    <Table sx={{ minWidth: 350 }} aria-label="simple table">
                        <TableHead>
                            <TableRow className={classes.primaryBackground}>
                                <TabelHeader />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {!viewHistoryLoading ? (
                                <>
                                    {[...(viewHistoryData || [])]?.map((item, index) => (
                                        <TableRow
                                            style={{
                                                borderLeft: `0.5px solid ${theme.palette.grey[200]}`,
                                                borderTop: `0.5px solid ${theme.palette.grey[200]}`
                                            }}
                                            key={index}
                                        >
                                            <TableCell
                                                sx={{
                                                    wordBreak: 'break-word',
                                                    borderSpacing: '0px !important',
                                                    display: 'block',
                                                    borderTop: `0.5px solid ${theme.palette.grey[200]} !important`,
                                                    borderBottom: 'none',
                                                    width: '160px'
                                                }}
                                            >
                                                <Typography className={classes.normalText}>{item?.description}</Typography>
                                            </TableCell>

                                            <TableCell>
                                                <Typography className={classes.normalText}>{item?.category}</Typography>
                                            </TableCell>

                                            <TableCell sx={{ width: '150px' }}>
                                                <Typography className={classes.normalText}>{item?.couponUsageCount}</Typography>
                                            </TableCell>
                                            <TableCell sx={{ width: '150px' }}>
                                                <Typography className={classes.normalText}>{item?.maxUsageCount}</Typography>
                                            </TableCell>
                                            <TableCell sx={{ width: '150px' }}>
                                                <Typography className={classes.normalText}>{item?.createdBy}</Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Box display="flex" flexDirection="column">
                                                    <Typography className={classes.normalText}>{item?.createdAt}</Typography>
                                                    <Typography className={classes.smallText}>{item?.createdTime}</Typography>
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                    <NoViewHistoryAvailable />
                                </>
                            ) : (
                                <>
                                    <TableCell>
                                        <Skeleton variant="rectangular" width={100} height={30} />
                                    </TableCell>
                                    <TableCell>
                                        <Skeleton variant="rectangular" width={100} height={30} />
                                    </TableCell>
                                    <TableCell>
                                        <Skeleton variant="rectangular" width={100} height={30} />
                                    </TableCell>
                                    <TableCell>
                                        <Skeleton variant="rectangular" width={100} height={30} />
                                    </TableCell>
                                    <TableCell>
                                        <Skeleton variant="rectangular" width={100} height={30} />
                                    </TableCell>
                                    <TableCell>
                                        <Skeleton variant="rectangular" width={100} height={30} />
                                    </TableCell>
                                </>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </MainCard>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Box width="100%" display="flex" justifyContent="center">
                        <Button
                            onClick={() => setViewHistoryModal(false)}
                            variant="contained"
                            type="button"
                            sx={{ width: '240px', padding: '12px 0', marginTop: '30px' }}
                        >
                            Close
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </>
    );
};

const ViewHistoryModal = ({ viewHistoryModal, setViewHistoryModal }) => {
    const classes = useStyles();

    return (
        <DialogModal
            open={viewHistoryModal}
            bodyText={<ViewHistoryModalBody setViewHistoryModal={setViewHistoryModal} />}
            titleText="View History"
            titleClass={classes.documentTitle}
            onClose={() => setViewHistoryModal(false)}
        />
    );
};

export default ViewHistoryModal;
